import React from "react";
import Box from "@mui/material/Box";
import SalesByLocation from "./SalesByLocation";
import TransactionsByLocation from "./TransactionsByLocation";
import SalesInsightAreaRetail from "./SalesInsightAreaRetail";
import NetSalesAndTransactions from "./NetSalesAndTransactions";
import SalesQuantity from "./NetSalesLineBar";
import SalesByTender from "./SalesByTender";

const RetailBusinessDashboard = () => (
    <Box sx={{ width: '100%', flexGrow: 1, height: 'auto' }}>
        <Box sx={{ width: '100%', flexGrow: 1, display: 'flex', flexDirection: 'row' }}>
            <SalesInsightAreaRetail />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', width: 'auto', justifyContent: 'space-between' }}>
            <Box sx={{ width: '50%' }}>
                <SalesByLocation />
            </Box>
            <Box sx={{ width: '50%' }}>
                <TransactionsByLocation />
            </Box>
        </Box>
        <Box sx={{ marginY: '20px' }}>
            <NetSalesAndTransactions />
        </Box>
        <Box sx={{ marginY: '20px', display: 'flex', flexDirection: 'row' }}>
            <Box sx={{ width: '50%', display: 'flex' }}>
                <SalesQuantity />
            </Box>
            <Box sx={{ width: '50%', display: 'flex' }}>
                <SalesByTender />
            </Box>
        </Box>
    </Box>

);

export default RetailBusinessDashboard;
